
import { Navigate } from "react-router";
import { useEffect, type JSX } from "react";
import { Controller, useForm } from "react-hook-form"
import { FloatingInputBootStrap } from "../Common/FloatingInputBootstrap";
import { useAddTypeFraisMutation } from "../../stores/OkOkStore";
import type { ResponseError } from "../../types/CommonReponse";
import type { TypeFrais } from "../../types/TypeFrais";
import TinyMceEditor from "../Common/TinyMceEditor";
import { useTrads } from "../../contexts/trads/useTrads";
import AttachmentSelector from "../Common/AttachmentSelector";

export function  TypeFraisInsertForm (): JSX.Element {
    const  type_frais:Partial<TypeFrais>={};
    const [addTypeFrais,result]=useAddTypeFraisMutation();
    const { register, handleSubmit,control,setValue,setError, formState: { errors } } = useForm({
        defaultValues:type_frais,
        //shouldUseNativeValidation: true,
        mode:'onBlur',
    });
    const {translate}=useTrads();
    useEffect(()=>{
        if(result.error && 'data' in result.error) {
            const server_error:ResponseError=result.error as ResponseError;
            const errors =server_error.data.error;
            if(errors){
                for (const i in errors) {
                        // @ts-expect-error i est connu!
                        setError(i, {type:'validate',message: translate(errors[i])});  
                }
                result.reset();
            }
        }
    },[setError,result,translate]);
    
    return (
        result.isSuccess ? <Navigate to={`/type_frais/${result.data.id.toString()}`} state={{"modified":true}}></Navigate>  :(
        result.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>:
        result.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>:
        <form className="row" onSubmit={(event) => void handleSubmit(addTypeFrais)(event)}>
            <div className="col-6  mb-3">
                <FloatingInputBootStrap
                    name="name"
                    label={translate('type_frais_nom')}
                    type="text"
                    errors={errors}
                    registerOutput= {register("name", {
                        required: translate("type_frais_error_nom_requis"),
                        minLength: 2
                    })} 
                />

            </div>
            <div className="col-12  mb-3">
                <TinyMceEditor
                    control={control}
                    name="description"
                    label={translate('type_frais_description')}
                    onChange={(data) => {setValue('description',data,{shouldValidate:true});}}
                />
            </div>

            <div className="col-12  mb-3">
                <p>{translate('type_frais_picto')}</p>
                <Controller
                        control={control}
                        name="picto"
                        render={({ field }) => <AttachmentSelector {...field} />}
                />
            </div>

            <div className="col-4  mb-3">
                <button type="submit">{translate('form_submit')}</button>
            </div>
        </form>
        )
    )
};

export default TypeFraisInsertForm;

